import { render } from "./CrossConnectDetail.vue?vue&type=template&id=6674bf76"
import script from "./CrossConnectDetail.vue?vue&type=script&lang=js"
export * from "./CrossConnectDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__